import styles from "./UnauthorizedPage.module.scss";
import { Link } from "react-router";
import React from "react";

function UnauthorizedPage() {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.errorContainer}>
        <h1 className={styles.heading}>Forbidden</h1>
        <p className={styles.description}>
          You are not authrozied to view this page
        </p>
        <div className={styles.linkContainer}>
          <Link className={styles.link} to="/admin/reports/doorhistory">
            Go to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}

export default UnauthorizedPage;
